import React, { useState, useEffect, useRef, ChangeEvent } from 'react';
import './LandingEdition.css';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import EditorAccordion from './EditorAccordion';  // Importa el acordeón
import SocialLinksEditor from './SocialLinksEditor';  // Importa el acordeón
import ServicesEditor from './ServicesEditor';
import GalleryImagesEditor from './GalleryImagesEditor';
import TestimonialsEditor from './TestimonialsEditor';
import ButtonsEditor from './ButtonsEditor';
import MainSectionEditor from './MainSectionEditor';
import GenerateUrl from './GenerateUrl';
import EditableSection from './EditableSection';
import SplitSectionEditor from './SplitSectionEditor';
import SliderImagesEditor from './SliderImagesEditor';

const LandingEdition: React.FC = () => {
  const history = useHistory();
  const [templateNumber, setTemplateNumber] = useState<number | null>(null);
  const [selectedSection, setSelectedSection] = useState<string | null>(null);
  const [editableContent, setEditableContent] = useState<{ [key: string]: string }>({});
  const [editMode, setEditMode] = useState<boolean>(false);
  const [selectedFont, setSelectedFont] = useState<string>('Open Sans');
  const [fontsList, setFontsList] = useState<string[]>([]);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [button1Text, setButton1Text] = useState('');
  const [button2Text, setButton2Text] = useState('');
  const [button3Text, setButton3Text] = useState(''); // Nuevo
  const [button4Text, setButton4Text] = useState(''); // Nuevo
  const [button5Text, setButton5Text] = useState(''); // Nuevo
  const [button6Text, setButton6Text] = useState(''); // Nuevo
  const [headerColor, setHeaderColor] = useState<string>('#ffffff');
  const [servicesColor, setServicesColor] = useState<string>('#ffffff');
  const [footerColor, setFooterColor] = useState<string>('#ffffff');
  const [isGeneratingUrl, setIsGeneratingUrl] = useState(false);
  const [deploymentUrl, setDeploymentUrl] = useState<string | null>(null); // Para guardar la URL final
  const iframeDocument = iframeRef.current?.contentDocument;
  const [mainImage, setMainImage] = useState<string>('thumb1.jpg'); // Estado para la imagen principal grande
  const [socialLinks, setSocialLinks] = useState({
    facebook: '',
    twitter: '',
    instagram: ''
  });
  // Cambiados: Estado para el título y párrafo de la sección ¿Qué hacemos?
  const [aboutTitle, setAboutTitle] = useState<string>("¿Qué hacemos?");
  const [aboutParagraph, setAboutParagraph] = useState<string>("Dolor sit amet, consectetur adipiscing elit. Mauris pellentesque volutpat cursus.");

  const handleDownload = async () => {
    try {
      const landingData = JSON.parse(localStorage.getItem('landingData') || '{}');
      const templateNumber = localStorage.getItem('selectedTemplate');
      const logo = landingData.logo; // Logo almacenado en localStorage

      const response = await axios.post('http://localhost:3001/download-landing', {
        templateNumber,
        landingData,
        logo,
      }, {
        responseType: 'blob', // Para manejar el archivo zip en la respuesta
      });

      // Crear un enlace para descargar el archivo zip
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Landing_${templateNumber}.zip`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error al descargar la landing page:', error);
    }
  };
  const handleSaveSection = (newTitle: string, newParagraph: string) => {
    setAboutTitle(newTitle);
    setAboutParagraph(newParagraph);

    // Guardar en localStorage
    const landingData = JSON.parse(localStorage.getItem('landingData') || '{}');
    landingData.aboutTitle = newTitle; // Cambiado a 'aboutTitle'
    landingData.aboutParagraph = newParagraph; // Cambiado a 'aboutParagraph'
    localStorage.setItem('landingData', JSON.stringify(landingData));

    // Aplicar cambios en el iframe
    const iframeDocument = iframeRef.current?.contentDocument;
    if (iframeDocument) {
      const titleElement = iframeDocument.querySelector('.content-container h2');
      const paragraphElement = iframeDocument.querySelector('.content-container .column p');

      if (titleElement) titleElement.textContent = newTitle;
      if (paragraphElement) paragraphElement.textContent = newParagraph;
    }
  };
  const handleHeaderColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    setHeaderColor(color);
    applyColorToSection('header', color);
  };

  const handleServicesColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    setServicesColor(color);
    applyColorToSection('services', color);
  };

  const handleFooterColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    setFooterColor(color);
    applyColorToSection('footer', color);
  };

  const applyColorToSection = (section: string, color: string) => {
    const iframeDocument = iframeRef.current?.contentDocument;
    if (iframeDocument) {
      let element: HTMLElement | null = null;
      switch (section) {
        case 'header':
          element = iframeDocument.querySelector('header');
          break;
        case 'services':
          element = iframeDocument.querySelector('.services-section');
          break;
        case 'footer':
          element = iframeDocument.querySelector('footer');
          break;
        default:
          break;
      }

      if (element) {
        element.style.backgroundColor = color;
      }
    }
  };

  useEffect(() => {
    const storedLinks = localStorage.getItem('socialLinks');
    if (storedLinks) {
      setSocialLinks(JSON.parse(storedLinks));
    }
  }, []);

  useEffect(() => {
    const selectedTemplate = localStorage.getItem('selectedTemplate');
    if (selectedTemplate) {
      setTemplateNumber(parseInt(selectedTemplate));
    } else {
      history.push('/LandingPageResult');
    }
  }, [history]);

  useEffect(() => {
    const fetchFonts = async () => {
      try {
        const response = await axios.get(
          'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBvnfsQyX7Km_B7Ti-5BuajfbQLiQBe4-4'
        );
        const fonts = response.data.items.map((font: any) => font.family);
        setFontsList(fonts);

        // Cargar dinámicamente las fuentes en el head
        response.data.items.forEach((font: any) => {
          const link = document.createElement('link');
          link.href = `https://fonts.googleapis.com/css2?family=${font.family.replace(/ /g, '+')}&display=swap`;
          link.rel = 'stylesheet';
          document.head.appendChild(link);
        });

        // Crear elementos invisibles para forzar la carga de las fuentes
        const fontLoaderDiv = document.createElement('div');
        fontLoaderDiv.style.position = 'absolute';
        fontLoaderDiv.style.visibility = 'hidden';

        response.data.items.forEach((font: any) => {
          const span = document.createElement('span');
          span.style.fontFamily = font.family;
          span.textContent = 'Sample Text';
          fontLoaderDiv.appendChild(span);
        });

        document.body.appendChild(fontLoaderDiv); // Añadir el div invisible al body para cargar las fuentes

      } catch (error) {
        console.error('Error fetching fonts:', error);
      }
    };

    fetchFonts();
  }, []);
  type ServicesMappingKeys = 'titulo-1' | 'subtitulo-1' | 'titulo-2' | 'subtitulo-2' | 'titulo-3' | 'subtitulo-3';

  const applyChangesToIframe = () => {
    const iframeDocument = iframeRef.current?.contentDocument;

    if (iframeDocument) {
      const sectionToIframeId: { [key: string]: string } = {
        'imagen': 'main-image',  // Esto se refiere a la clase o el ID que tiene el background
        'main-title': 'main-title',
        'main-paragraph': 'main-paragraph',
        'main-subparagraph': 'main-subparagraph',
        // Agrega más mapeos según sea necesario
      };

      Object.entries(editableContent).forEach(([section, content]) => {
        const elementIdInIframe = sectionToIframeId[section] || section;
        const element = iframeDocument.getElementById(elementIdInIframe);

        if (element) {
          console.log(`Elemento encontrado con ID ${elementIdInIframe}:`, element);
          console.log(`Tag name del elemento: ${element.tagName}`);

          // Si es un img, actualizar el src
          if (element.tagName.toLowerCase() === 'img') {
            console.log(`Actualizando imagen con ID ${elementIdInIframe} a ${content}`);
            (element as HTMLImageElement).src = content;
          }
          // Si es el main-image, cambia el background-image
          else if (elementIdInIframe === 'main-image') {
            console.log(`Actualizando background-image del elemento con ID ${elementIdInIframe}`);
            (element as HTMLElement).style.backgroundImage = `url(${content})`;
            (element as HTMLElement).style.backgroundSize = 'cover';  // Ajuste adicional si es necesario
            (element as HTMLElement).style.backgroundPosition = 'center'; // Ajuste adicional si es necesario
          }
          // Actualizar otros textos
          else {
            console.log(`Actualizando texto de elemento con ID ${elementIdInIframe}`);
            element.textContent = content;
          }
        } else {
          console.warn(`No se encontró el elemento con ID ${elementIdInIframe} en el iframe`);
        }
      });
      const mainImageElement = iframeDocument.getElementById('pexels-media-image');
      if (mainImageElement && mainImageElement instanceof HTMLImageElement) {
        mainImageElement.src = mainImage;
      }
      // Verifica si hay una sección seleccionada y contenido para esa sección
      if (selectedSection && editableContent[selectedSection]) {
        const element = iframeDocument.getElementById(selectedSection);

        // Verifica si es una imagen y actualiza su `src`
        if (element instanceof HTMLImageElement) {
          element.src = editableContent[selectedSection];
        }
        const thumbElement = iframeDocument.getElementById(selectedSection);
        if (thumbElement && thumbElement instanceof HTMLImageElement) {
          thumbElement.src = editableContent[selectedSection];
        }

        // Si no es una imagen, revisa si es un testimonio y actualiza la imagen de fondo o el texto
        if (element) {
          if (selectedSection.startsWith('testimonial')) {
            // Actualiza la imagen de fondo en el testimonio
            const imgElement = iframeDocument.querySelector(`.card:nth-child(${selectedSection.split('-')[1]}) .testimonial-image`) as HTMLDivElement;
            if (imgElement && editableContent[`${selectedSection}-image`]) {
              imgElement.style.backgroundImage = `url(${editableContent[`${selectedSection}-image`]})`;
            }

            // Actualiza el texto del testimonio
            const textElement = iframeDocument.querySelector(`.card:nth-child(${selectedSection.split('-')[1]}) .testimonial-text p`) as HTMLParagraphElement;
            if (textElement) {
              textElement.textContent = editableContent[selectedSection];
            }
          } else {
            // Si es otro tipo de elemento, actualiza su texto
            element.textContent = editableContent[selectedSection];
          }
        }
      }

      // Actualiza el texto y los enlaces de los botones
      const button1 = iframeDocument.getElementById('button-1');
      if (button1) {
        button1.textContent = button1Text || 'Texto del botón 1';
        button1.setAttribute('href', editableContent['button-1-link'] || '#');
      }

      // Mapeo de secciones de servicios
      const servicesMapping: { [key: string]: string } = {
        'titulo-1': 'titulo-1',
        'subtitulo-1': 'subtitulo-1',
        'titulo-2': 'titulo-2',
        'subtitulo-2': 'subtitulo-2',
        'titulo-3': 'titulo-3',
        'subtitulo-3': 'subtitulo-3',
      };

      // Verificación de claves válidas en servicesMapping
      Object.entries(editableContent).forEach(([section, content]) => {
        if (section in servicesMapping) {
          const elementIdInIframe = servicesMapping[section];
          const element = iframeDocument.getElementById(elementIdInIframe);

          if (element) {
            element.textContent = content;
          }
        }
      });
      const button2 = iframeDocument.getElementById('button-2');
      if (button2) {
        button2.textContent = button2Text || 'Texto del botón 2';
        button2.setAttribute('href', editableContent['button-2-link'] || '#');
      }

      // Aplica la tipografía seleccionada
      iframeDocument.body.style.fontFamily = selectedFont;
    }
  };


  // Llama a esta función cada vez que se guarden los cambios
  useEffect(() => {
    if (iframeRef.current) {
      applyChangesToIframe();
    }
  }, [editableContent]);

  useEffect(() => {
    if (iframeRef.current) {
      applyChangesToIframe();
    }
  }, [editableContent]);

  useEffect(() => {
    // Cargar editableContent desde localStorage
    const storedEditableContent = localStorage.getItem('editableContent');
    if (storedEditableContent) {
      setEditableContent(JSON.parse(storedEditableContent));
    }

    // Cargar selectedFont desde localStorage
    const storedSelectedFont = localStorage.getItem('selectedFont');
    if (storedSelectedFont) {
      setSelectedFont(storedSelectedFont);
    }

    // Cargar socialLinks desde localStorage
    const storedSocialLinks = localStorage.getItem('socialLinks');
    if (storedSocialLinks) {
      setSocialLinks(JSON.parse(storedSocialLinks));
    }
  }, []);
  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.onload = () => {
        applyChangesToIframe();
      };
    }
  }, [iframeRef]);

  const handleMainImageChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

    if (file) {
      const formData = new FormData();
      formData.append('landingImage', file);

      try {
        // Subir la imagen al servidor
        const response = await axios.post(`${backendUrl}/upload-landing-image`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const imageUrl = response.data.landingImageUrl;

        // Actualizar editableContent con la URL de la nueva imagen
        setEditableContent((prev) => ({
          ...prev,
          'main-image': imageUrl,
        }));

        // Actualizar el iframe directamente
        const iframeDocument = iframeRef.current?.contentDocument;
        if (iframeDocument) {
          const heroElement = iframeDocument.querySelector('.hero');
          if (heroElement instanceof HTMLElement) {
            heroElement.style.backgroundImage = `url(${imageUrl})`; // Cambiar la imagen de fondo
          }
        }
      } catch (error) {
        console.error('Error al subir la imagen principal:', error);
      }
    }
  };
  const handleSplitImageChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

    if (file) {
      const formData = new FormData();
      formData.append('landingImage', file);

      try {
        // Subir la imagen al servidor
        const response = await axios.post(`${backendUrl}/upload-landing-image`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const imageUrl = response.data.landingImageUrl;

        // Actualizar el estado editableContent con la URL de la nueva imagen
        setEditableContent((prev) => ({
          ...prev,
          'split-section-image': imageUrl,
        }));

        // Actualizar el iframe directamente
        const iframeDocument = iframeRef.current?.contentDocument;
        if (iframeDocument) {
          const splitImageElement = iframeDocument.getElementById('split-section-image');
          if (splitImageElement && splitImageElement instanceof HTMLImageElement) {
            splitImageElement.src = imageUrl;  // Cambiar la imagen en el iframe
          }
        }
      } catch (error) {
        console.error('Error al subir la imagen en split-section:', error);
      }
    }
  };

  // Manejar el cambio de imagen del carrusel desde el input de archivo
  const handleCarouselImageChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && selectedSection && selectedSection.startsWith('pexels-thumb')) {
      const formData = new FormData();
      formData.append('carouselImage', file);

      try {
        // Subir la imagen al backend
        const response = await axios.post('http://localhost:3001/upload-carousel-image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const imageUrl = response.data.landingImageUrl;
        setEditableContent((prev) => ({
          ...prev,
          [selectedSection]: imageUrl,
        }));
        localStorage.setItem('editableContent', JSON.stringify({
          ...editableContent,
          [selectedSection]: imageUrl,
          'pexels-media-image': imageUrl,
        }));

        // Actualizar la imagen principal en el iframe
        const iframeDocument = iframeRef.current?.contentDocument;
        if (iframeDocument) {
          const mainImageElement = iframeDocument.getElementById('pexels-media-image');
          if (mainImageElement && mainImageElement instanceof HTMLImageElement) {
            mainImageElement.src = imageUrl; // Cambiar la imagen en el iframe
            console.log(`Imagen principal cambiada a: ${imageUrl}`);
          }

          // Actualizar también la miniatura
          const thumbElement = iframeDocument.getElementById(selectedSection);
          if (thumbElement && thumbElement instanceof HTMLImageElement) {
            thumbElement.src = editableContent[selectedSection];  // Asegúrate de que esto se ejecute correctamente
          }

        }
      } catch (error) {
        console.error('Error al subir la imagen:', error);
      }
    }
  };


  const handleCarouselImageClick = (imageId: string) => {
    const newImageUrl = editableContent[imageId]; // Obtener la URL de la imagen desde editableContent
    if (newImageUrl) {
      setMainImage(newImageUrl); // Actualizar el estado de la imagen principal

      // Actualizar también la imagen principal en el iframe
      const iframeDocument = iframeRef.current?.contentDocument;
      if (iframeDocument) {
        const mainImageElement = iframeDocument.getElementById('pexels-media-image'); // Cambia esto si el ID de la imagen principal es otro
        if (mainImageElement && mainImageElement instanceof HTMLImageElement) {
          mainImageElement.src = newImageUrl; // Cambiar la imagen principal en el iframe
        }
      }
    }
  };
  useEffect(() => {
    if (iframeRef.current) {
      applyChangesToIframe();
    }
  }, [editableContent, selectedFont, socialLinks, button1Text, button2Text, selectedSection]);
  useEffect(() => {
    localStorage.setItem('editableContent', JSON.stringify(editableContent));
  }, [editableContent]);


  useEffect(() => {
    const contentToStore = { ...editableContent };

    // Remover propiedades que son imágenes para no saturar localStorage
    Object.keys(contentToStore).forEach((key) => {
      if (key.includes('image')) {
        delete contentToStore[key];
      }
    });

    localStorage.setItem('editableContent', JSON.stringify(contentToStore));
  }, [editableContent]);

  useEffect(() => {
    if (iframeRef.current && editableContent) {
      applyChangesToIframe();
    }
  }, [editableContent, selectedFont, socialLinks, button1Text, button2Text, selectedSection]);



  useEffect(() => {
    const storedEditableContent = localStorage.getItem('editableContent');
    if (storedEditableContent) {
      setEditableContent(JSON.parse(storedEditableContent));
    }

    const storedSelectedFont = localStorage.getItem('selectedFont');
    if (storedSelectedFont) {
      setSelectedFont(storedSelectedFont);
    }

    const storedSocialLinks = localStorage.getItem('socialLinks');
    if (storedSocialLinks) {
      setSocialLinks(JSON.parse(storedSocialLinks));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('editableContent', JSON.stringify(editableContent));
  }, [editableContent]);

  useEffect(() => {
    localStorage.setItem('selectedFont', selectedFont);
  }, [selectedFont]);

  useEffect(() => {
    localStorage.setItem('socialLinks', JSON.stringify(socialLinks));
  }, [socialLinks]);

  useEffect(() => {
    if (iframeRef.current) {
      applyChangesToIframe();
    }
  }, [editableContent, selectedFont, socialLinks, button1Text, button2Text, selectedSection]);


  useEffect(() => {
    if (editMode && selectedSection) {
      applyChangesToIframe();
    }
  }, [editableContent, selectedFont, selectedSection, editMode]);

  const handleSocialLinkChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    // Actualiza el estado de socialLinks
    setSocialLinks(prev => ({
      ...prev,
      [name]: value,
    }));

    // Actualiza también editableContent para reflejar los cambios
    setEditableContent(prev => ({
      ...prev,
      [`${name}-link`]: value,
    }));
  };

  const handleSaveChanges = async (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    try {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const templateNumber = localStorage.getItem('selectedTemplate'); // Asegúrate de obtener el templateNumber del localStorage

      if (!token) {
        alert('No estás autenticado.');
        return;
      }

      if (userId && templateNumber) {
        const customizations = Object.entries(editableContent).map(([elementId, content]) => ({
          elementId,
          content,
        }));

        // Crear el payload que enviarás al backend
        const jsonPayload = {
          userId: parseInt(userId), // Puede que no sea necesario en tu caso, pero lo dejamos
          templateNumber,           // Enviar el número de la plantilla
          customizations,           // Las personalizaciones
          fontFamily: selectedFont,  // La tipografía seleccionada
          socialLinks,              // Los enlaces de redes sociales
        };

        console.log("JSON a enviar:", jsonPayload); // Revisa el JSON en consola antes de enviarlo

        // Enviar los cambios al backend
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // URL de tu backend
        const response = await axios.post(`${backendUrl}/save-landing`, jsonPayload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        alert('Landing page guardada con éxito');
        setEditMode(false);
      }
    } catch (error) {
      console.error('Error guardando la landing page:', error);
      alert('Hubo un error al guardar la landing page. Verifica la consola para más detalles.');
    }
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setTimeout(() => {
      setSelectedSection(null);
    }, 0);
  };
  useEffect(() => {
    const storedHeaderColor = localStorage.getItem('headerColor');
    const storedServicesColor = localStorage.getItem('servicesColor');
    const storedFooterColor = localStorage.getItem('footerColor');

    if (storedHeaderColor) setHeaderColor(storedHeaderColor);
    if (storedServicesColor) setServicesColor(storedServicesColor);
    if (storedFooterColor) setFooterColor(storedFooterColor);
  }, []);

  useEffect(() => {
    localStorage.setItem('headerColor', headerColor);
  }, [headerColor]);

  useEffect(() => {
    localStorage.setItem('servicesColor', servicesColor);
  }, [servicesColor]);

  useEffect(() => {
    localStorage.setItem('footerColor', footerColor);
  }, [footerColor]);

  const handleFontChange = (event: { target: { value: any; }; }) => {
    const newFont = event.target.value;
    setSelectedFont(newFont);

    // Guardar la fuente seleccionada en localStorage
    localStorage.setItem('selectedFont', newFont);

    // Cargar la nueva fuente en el documento principal
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css?family=${newFont.replace(/ /g, '+')}&display=swap`;
    document.head.appendChild(link);

    // También asegúrate de cargar la fuente en el iframe
    const iframeDocument = iframeRef.current?.contentDocument;
    if (iframeDocument) {
      const iframeLink = iframeDocument.createElement('link');
      iframeLink.rel = 'stylesheet';
      iframeLink.href = `https://fonts.googleapis.com/css?family=${newFont.replace(/ /g, '+')}&display=swap`;
      iframeDocument.head.appendChild(iframeLink);

      // Aplicar la nueva fuente al cuerpo del iframe
      iframeDocument.body.style.fontFamily = newFont;
    }
  };

  useEffect(() => {
    // Guardar el número de plantilla seleccionada en el localStorage
    if (templateNumber) {
      localStorage.setItem('selectedTemplate', templateNumber.toString());
    }
  }, [templateNumber]);

  const handleGenerateUrl = async () => {
    setIsGeneratingUrl(true);
    try {
      const repoUrl = localStorage.getItem('repoUrl');
      const companyName = localStorage.getItem('companyName'); // Obtener companyName
      const templateNumber = localStorage.getItem('selectedTemplate'); // Obtener templateNumber

      console.log('Repo URL:', repoUrl);
      console.log('Company Name:', companyName);
      console.log('Template Number:', templateNumber);

      if (!repoUrl || !companyName || !templateNumber) {
        throw new Error('Faltan datos requeridos: repoUrl, companyName o templateNumber.');
      }

      // Obtener los datos dinámicos como en la función de descarga
      const landingData = JSON.parse(localStorage.getItem('landingData') || '{}');
      const logo = landingData.logo; // Logo almacenado en localStorage

      // Ahora vamos a preparar los archivos dinámicos y subirlos al repo
      const uploadResponse = await axios.post('http://localhost:3001/upload-to-repo', {
        repoUrl,
        templateNumber,
        landingData,  // Pasamos también los datos dinámicos
        logo          // Incluimos el logo dinámico
      });

      console.log('Archivos subidos con éxito:', uploadResponse.data);

      // Hacer el despliegue en Vercel
      const deployResponse = await axios.post('http://localhost:3001/deploy', {
        repoUrl,
        companyName
      });

      const deploymentUrl = deployResponse.data.deploymentUrl; // Ahora esta será la URL de producción
      console.log('Despliegue exitoso en Vercel:', deploymentUrl);
      setDeploymentUrl(deploymentUrl); // Aquí guardamos la URL de producción
    } catch (error) {
      console.error('Error al generar la URL:', error);
      if (axios.isAxiosError(error)) {
        // Si es un error de Axios, manejamos los detalles de respuesta y solicitud
        if (error.response) {
          alert(`Error del servidor: ${error.response.data.error || 'Error desconocido del servidor'}`);
        } else if (error.request) {
          alert('Error de red, no se pudo conectar al servidor.');
        }
      } else if (error instanceof Error) {
        alert(`Error: ${error.message}`);
      } else {
        alert('Ocurrió un error desconocido.');
      }
    } finally {
      setIsGeneratingUrl(false); // Finalizar el estado de carga
    }
  };
  const [splitSectionTitle, setSplitSectionTitle] = useState<string>('Lorem Ipsum dolor sit');
  const [splitSectionParagraph1, setSplitSectionParagraph1] = useState<string>('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque volutpat cursus.');
  const [splitSectionParagraph2, setSplitSectionParagraph2] = useState<string>('Dolor sit amet, consectetur adipiscing elit. Mauris pellentesque volutpat cursus.');
  const [splitSectionImage, setSplitSectionImage] = useState<string>('lambo.png'); // Valor por defecto de la imagen

  useEffect(() => {
    if (iframeRef.current) {
      const iframeDocument = iframeRef.current.contentDocument;
      if (iframeDocument) {
        const titleElement = iframeDocument.getElementById('split-section-title');
        if (titleElement) {
          titleElement.textContent = splitSectionTitle;
        }

        const paragraph1Element = iframeDocument.getElementById('split-section-paragraph1');
        if (paragraph1Element) {
          paragraph1Element.textContent = splitSectionParagraph1;
        }

        const paragraph2Element = iframeDocument.getElementById('split-section-paragraph2');
        if (paragraph2Element) {
          paragraph2Element.textContent = splitSectionParagraph2;
        }

        const imageElement = iframeDocument.getElementById('split-section-image');
        if (imageElement && imageElement instanceof HTMLImageElement) {
          imageElement.src = splitSectionImage;
        }
      }
    }
  }, [splitSectionTitle, splitSectionParagraph1, splitSectionParagraph2, splitSectionImage]);

  useEffect(() => {
    // Cargar la tipografía almacenada en localStorage
    const storedFont = localStorage.getItem('selectedFont');
    if (storedFont) {
      setSelectedFont(storedFont);

      // Cargar la fuente seleccionada en el documento principal
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css?family=${storedFont.replace(/ /g, '+')}&display=swap`;
      document.head.appendChild(link);

      // También cargar la fuente en el iframe si está disponible
      const iframeDocument = iframeRef.current?.contentDocument;
      if (iframeDocument) {
        const iframeLink = iframeDocument.createElement('link');
        iframeLink.rel = 'stylesheet';
        iframeLink.href = `https://fonts.googleapis.com/css?family=${storedFont.replace(/ /g, '+')}&display=swap`;
        iframeDocument.head.appendChild(iframeLink);

        // Aplicar la fuente al cuerpo del iframe
        iframeDocument.body.style.fontFamily = storedFont;
      }
    }
  }, [iframeRef]);

  const handleEditChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    if (name === 'facebook' || name === 'twitter' || name === 'instagram') {
      handleSocialLinkChange(event as React.ChangeEvent<HTMLInputElement>); // Asegúrate de que sea solo HTMLInputElement
    } else if (name === 'button-1-text') {
      setButton1Text(value);
      setEditableContent(prev => ({
        ...prev,
        'button-1-text': value,
      }));
    } else if (name === 'button-2-text') {
      setButton2Text(value);
      setEditableContent(prev => ({
        ...prev,
        'button-2-text': value,
      }));
    } else {
      setEditableContent(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSectionClick = (section: string) => {
    setSelectedSection(section);
    setEditMode(true);

    const iframeDocument = iframeRef.current?.contentDocument;
    if (iframeDocument) {
      iframeDocument.querySelectorAll('.highlighted-section').forEach((el) => {
        el.classList.remove('highlighted-section');
      });

      const elementToHighlight = iframeDocument.getElementById(section);
      if (elementToHighlight) {
        elementToHighlight.classList.add('highlighted-section');
      }

      if (section === 'button-1-link') {
        setButton1Text(iframeDocument.getElementById('button-1')?.textContent || '');
        setEditableContent(prev => ({
          ...prev,
          'button-1-link': iframeDocument.getElementById('button-1')?.getAttribute('href') || '#'
        }));
      } else if (section === 'button-2-link') {
        setButton2Text(iframeDocument.getElementById('button-2')?.textContent || '');
        setEditableContent(prev => ({
          ...prev,
          'button-2-link': iframeDocument.getElementById('button-2')?.getAttribute('href') || '#'
        }));
      } else if (section.startsWith('testimonial')) {
        // Si es un testimonio, cargar el texto y la imagen correspondiente
        setEditableContent(prev => ({
          ...prev,
          [section]: prev[section] || '',
          [`${section}-image`]: prev[`${section}-image`] || '',
        }));
      }
    }

    // Asegurarse de que el panel de edición esté visible
    setEditMode(true);
  };


  return (
    <div className="landing-edition-wrapper">
      <Helmet>
        <title>Resultado Landing</title>
      </Helmet>
      {templateNumber && (
        <div className="editor-main">
          <iframe
            src={`/Plantillas/Plantilla${templateNumber}/index.html`}
            title={`Plantilla ${templateNumber}`}
            ref={iframeRef}
            className="template-preview"
          ></iframe>
        </div>
      )}
      <div className="editor-sidebar">
        <ul>
          <EditorAccordion
            selectedFont={selectedFont}
            handleFontChange={handleFontChange}
            fontsList={fontsList}
            headerColor={headerColor}
            handleHeaderColorChange={handleHeaderColorChange}
            servicesColor={servicesColor}
            handleServicesColorChange={handleServicesColorChange}
            footerColor={footerColor}
            handleFooterColorChange={handleFooterColorChange}
          />
          <MainSectionEditor
            selectedSection={selectedSection}
            editMode={editMode}
            editableContent={editableContent}
            handleSectionClick={handleSectionClick}
            handleEditChange={handleEditChange}
            handleMainImageChange={handleMainImageChange}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
          />
          <EditableSection
            title={aboutTitle}  // Cambiado a 'aboutTitle'
            paragraph={aboutParagraph}  // Cambiado a 'aboutParagraph'
            onSave={handleSaveSection}
          />
          <SplitSectionEditor
            title={splitSectionTitle}
            paragraph1={splitSectionParagraph1}
            paragraph2={splitSectionParagraph2}
            imageSrc={splitSectionImage}
            onSave={(newTitle, newParagraph1, newParagraph2, newImageSrc) => {
              setSplitSectionTitle(newTitle);
              setSplitSectionParagraph1(newParagraph1);
              setSplitSectionParagraph2(newParagraph2);
              setSplitSectionImage(newImageSrc);
            }}
          />


          <ButtonsEditor
            selectedSection={selectedSection}
            editMode={editMode}
            editableContent={editableContent}
            button1Text={button1Text}
            button2Text={button2Text}
            button3Text={button3Text} // Nuevo
            button4Text={button4Text} // Nuevo
            button5Text={button5Text} // Nuevo
            button6Text={button6Text} // Nuevo
            handleSectionClick={handleSectionClick}
            handleEditChange={handleEditChange}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
            setButton1Text={setButton1Text}
            setButton2Text={setButton2Text}
            setButton3Text={setButton3Text} // Nuevo
            setButton4Text={setButton4Text} // Nuevo
            setButton5Text={setButton5Text} // Nuevo
            setButton6Text={setButton6Text} // Nuevo
          />

          <GalleryImagesEditor
            selectedSection={selectedSection}
            editMode={editMode}
            editableContent={editableContent}
            handleSectionClick={handleSectionClick}
            handleCarouselImageChange={handleCarouselImageChange}
            handleCarouselImageClick={handleCarouselImageClick}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
          />
          <ServicesEditor
            selectedSection={selectedSection}
            editMode={editMode}
            editableContent={editableContent}
            handleSectionClick={handleSectionClick}
            handleEditChange={handleEditChange}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
          />
          <SliderImagesEditor
            editableContent={editableContent}
            handleImageChange={(imageId, newImageUrl) => {
              setEditableContent((prev) => ({
                ...prev,
                [imageId]: newImageUrl,
              }));

              const iframeDocument = iframeRef.current?.contentDocument;
              if (iframeDocument) {
                const imageElement = iframeDocument.getElementById(imageId) as HTMLImageElement;
                if (imageElement) {
                  imageElement.src = newImageUrl;
                }
              }
            }}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
          />

          <TestimonialsEditor
            selectedSection={selectedSection}
            editMode={editMode}
            editableContent={editableContent}
            handleSectionClick={handleSectionClick}
            handleEditChange={handleEditChange}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
            iframeRef={iframeRef}
            setEditableContent={setEditableContent}
          />
          <SocialLinksEditor
            socialLinks={socialLinks}
            handleSocialLinkChange={handleSocialLinkChange}
            handleSaveChanges={handleSaveChanges}
            handleCancelEdit={handleCancelEdit}
          />
          <GenerateUrl
            isGeneratingUrl={isGeneratingUrl}
            handleGenerateUrl={handleGenerateUrl}
            deploymentUrl={deploymentUrl}
          />
          <li>
            <button className='Download-button' onClick={handleDownload}> <h3>Descargar Plantilla</h3></button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LandingEdition;
function saveAs(zipBlob: Blob, arg1: string) {
  throw new Error('Function not implemented.');
}

